import { useEffect, useEffectEvent, useRef } from "react";

export const useIntersectionObserver = <T extends HTMLElement = HTMLDivElement>(
  onObserve: () => unknown,
) => {
  const intersectorRef = useRef<T>(null);

  const onObserveEvent = useEffectEvent(() => {
    onObserve();
  });

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        onObserveEvent();
      }
    });
    if (intersectorRef.current) {
      observer.observe(intersectorRef.current);
      return () => {
        observer.disconnect();
      };
    }
  }, []);

  return intersectorRef;
};
